// extracted by mini-css-extract-plugin
export default {"tag":"qA3NG7","extended":"cp9Q2z"};